<script>
import Layout from '@layouts/main';
import CarForm from '@views/cars/form';

export default {
  components: {
    Layout,
    CarForm,
  },
  page() {
    return {
      title: this.$t('titles.create_car'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.cars'),
          to: { name: 'cars.index' },
        },
        {
          text: this.$t('titles.create_car'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'cars.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_car')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CarForm @submitted="create" />
    </b-card>
  </Layout>
</template>
